import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { getSidebarStatus, setSidebarStatus } from '@/utils/cookies';
import store from '@/store';

export enum DeviceType {
  Mobile,
  Desktop,
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  },
  enlarged: {
    isShow: boolean,
    initNum: number,
    imgList: [],
  },
  evaluated: boolean,
  themed: string
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: true,
    withoutAnimation: false
  }
  public device = DeviceType.Desktop

  public messages: any[] = []
  public enlarged: any = {
    isShow: false,
    initNum: 0,
    imgList: []
  }
  public evaluated = false
  public themed = 'theme1'

  get getEnlarged() {
    return this.enlarged;
  }

  @Mutation
  private PUSH_MESSAGE(data:any) {
    this.messages.push(data);
  }

  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = true;
    this.sidebar.withoutAnimation = withoutAnimation;
    // if (this.sidebar.opened) {
    //   setSidebarStatus('opened');
    // } else {
    //   setSidebarStatus('closed');
    // }
  }

  @Mutation
  private CLOSE_EVALUATED(value: boolean) {
    this.evaluated = value;
  }

  @Mutation
  private TOGGLE_THEME(value: string) {
    this.themed = value;
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device;
  }

  // @Mutation
  // private CLOSE_SIDEBAR(withoutAnimation: boolean) {
  //   this.sidebar.opened = false;
  //   this.sidebar.withoutAnimation = withoutAnimation;
  //   setSidebarStatus('closed');
  // }

  @Mutation
  private TOGGLE_ENLARGED(data: any) {
    this.enlarged.isShow = data.isShow;
    this.enlarged.initNum = data.initNum;
    this.enlarged.imgList = data.imgList;
  }

  @Action
  public PushMessage(data: any) {
    this.PUSH_MESSAGE(data);
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation);
  }

  // @Action
  // public CloseSideBar(withoutAnimation: boolean) {
  //   this.CLOSE_SIDEBAR(withoutAnimation);
  // }

  @Action
  public CloseEvaluated(value: boolean) {
    this.CLOSE_EVALUATED(value);
  }

  @Action
  public ToggleTheme(value: string) {
    this.TOGGLE_THEME(value);
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device);
  }

  // @Action
  // public toggleEnlarged(data: object) {
  //   this.TOGGLE_ENLARGED(data);
  // }
  @Action({ commit: 'TOGGLE_ENLARGED' })
  toggleEnlarged(data: object) {
    return data;
  }
}

export const AppModule = getModule(App);
